import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SubItemsIcon } from '@/shared/assets/icons/sub-items-icon';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { GroupInfoTag } from '@/shared/features/groups/components/group-info/group-info.styled';
import { TGroupInfoProps } from '@/shared/features/groups/components/group-info/group-info.types';

export const GroupInfo: React.FC<TGroupInfoProps> = ({
  resources,
  icon = <SubItemsIcon size="1rem" />,
  syncStatus,
}) => {
  const { t } = useTranslation();
  const total = resources.reduce((sum, resource) => sum + resource.count, 0);

  const renderItems = () => {
    if (total === 0) {
      return t('groups:group_empty.title');
    }

    return (
      <Stack gap="0.5rem" alignItems="flex-start">
        <Typography variant="p6">{t('common:content')}:</Typography>
        {resources.map((resource) => {
          if (resource.count === 0) {
            return null;
          }
          return (
            <Stack
              direction="row"
              gap="0.25rem"
              alignItems="center"
              key={resource.key}
            >
              {resource.icon}
              <Typography variant="p9">
                {resource.count} {resource.label}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    );
  };

  return (
    <Stack
      direction="row"
      gap="0.5rem"
      alignItems="center"
      justifyContent="center"
    >
      {syncStatus}
      <Tooltip title={renderItems()}>
        <GroupInfoTag icon={icon} label={total} />
      </Tooltip>
    </Stack>
  );
};
